import { resourceTypesGenerator } from '../../../utils';

export default resourceTypesGenerator('limitedWaiverOpportunity');
